import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({providedIn:'root'})
export class IframeRecivedService{
    public styleType!:number;
    public isDesignerModeSub:Subject<boolean>= new Subject();
    public isAppSub:Subject<boolean>=new Subject();
    public previewOpenSub = new BehaviorSubject<boolean>(false);
    public configImgSub=new BehaviorSubject<string|null>(null);
    public styleTypeSub=new BehaviorSubject<any>(this.styleType);

}